export type Environments = 'dev' | 'stage' | 'prod';
const devEnvironments = ['dev', 'stage'] as Environments[];

const currentReceiverUrl = new URL(window.location.href);
export const isRedirect = currentReceiverUrl.pathname.includes('redirect');

/**
 * Returns what environment we are running in.
 */
export default function getEnvironment() {
  const envFromUrl = (currentReceiverUrl.searchParams.get('env') as Environments) || 'prod';
  return isRedirect ? 'dev' : envFromUrl;
}

/**
 * Returns true if the environment is dev or stage.
 */
export const isDev = devEnvironments.includes(getEnvironment());

export const isCastAvailable = 'cast' in globalThis;
